/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import Loading from 'components/Loading/Loading';

import ActionDrawerHeader from 'views/ActionDrawer/components/ActionDrawerHeader/ActionDrawerHeader';

import ExportAssetDataForm from './ExportAssetDataForm/ExportAssetDataForm';
import ExportAssetDataSuccess from './ExportAssetDataSuccess/ExportAssetDataSuccess';
import ExportAssetDataError from './ExportAssetDataError/ExportAssetDataError';

type TypeProps = {|
  currentAccountDetails: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class ExportAssetData extends React.Component<*> {
  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { currentAccountDetails, actionDrawerStore }: TypeProps = this.props;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    return (
      <div className="action-drawer-form">
        <ActionDrawerHeader title={t('general:actions.export_all_asset_data')} />
        <ExportAssetDataForm currentAccountDetails={currentAccountDetails} />
      </div>
    );
  }
}
